import NewBooking from "./NewBooking";
import PendingBooking from "./PendingBooking";
import Report from "./Report";
import Dispatch from "./Dispatch";
export default { NewBooking, PendingBooking, Report, Dispatch };
